import { Button } from "@/components/ui/button"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"
import { motion } from "framer-motion"

export function CTA() {
  return (
    <section className="border-t">
      <div className="container py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative mx-auto flex max-w-[58rem] flex-col items-center justify-center gap-4 text-center"
        >
          <div className="absolute inset-0 -z-10 overflow-hidden rounded-[2rem]">
            <div className="absolute inset-0 bg-primary/5" />
            <div className="absolute inset-0 bg-grid-white/10 bg-[size:20px_20px] [mask-image:linear-gradient(0deg,transparent,black)]" />
          </div>
          <div className="space-y-4 rounded-[1.5rem] bg-background/95 px-8 py-12 backdrop-blur">
            <h2 className="font-heading text-3xl font-bold leading-[1.1] sm:text-4xl md:text-5xl">
              Ready to streamline your property maintenance?
            </h2>
            <p className="max-w-[85%] mx-auto leading-normal text-muted-foreground sm:text-lg sm:leading-7">
              Join thousands of property managers who trust FlexHelp to keep their properties in perfect condition.
            </p>
            <Link to="/register">
              <Button size="lg" className="mt-4 shadow-lg shadow-primary/20 hover:shadow-primary/30 transition-shadow">
                Start Your Free Trial
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}